import { render, staticRenderFns } from "./main-contact.vue?vue&type=template&id=4b37dfc6&scoped=true&"
import script from "./main-contact.vue?vue&type=script&lang=js&"
export * from "./main-contact.vue?vue&type=script&lang=js&"
import style0 from "./main-contact.vue?vue&type=style&index=0&id=4b37dfc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b37dfc6",
  null
  
)

export default component.exports